import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs';

@Injectable()
export class CustomLoaderService implements TranslateLoader {
  constructor(private inej: Injector) { }
  getTranslation(lang: string): Observable<any> {
    let http = this.inej.get(HttpClient);
    return http.get(`./assets/translate/core/${lang}.json`);
  }
}